import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setState,
  setUpdateQuizForm,
  updateWinnerPrizeNew,
} from "../redux/slice";
import { getLaws } from "../../components/LawCollegeQuiz/redux/lawCollegeSlice";
import { getQuizzes, updateQuiz } from "../redux/thunk";

export default function EditQuiz({ allotments }) {
  const { selectedQuiz, updateQuizForm } = useSelector(
    (state) => state.quizManagement
  );
  const { categories } = useSelector((state) => state.lawCollegeQuiz);
  const dispatch = useDispatch();
  const {
    id,
    title,
    start,
    registrationStart,
    registrationEnd,
    totalQuestions,
    questionDuration,
    correct,
    wrong,
    skipped,
    enableWrongMarks,
    enableSkippedMarks,
    registrationFeeMode,
    registrationCost,
    prizeDescription,
    winnerPrizes,
    about_quiz,
    quiz_terms,
    updated_by,
    law_selected,
    description,
  } = updateQuizForm;
  const data = selectedQuiz;
  const [state, setStatee] = useState({
    allotments: [],
  });
  const userId = JSON.parse(localStorage.getItem("user"))?.id;

  const formatToISTDatetimeLocal = (utcDateStr) => {
    if (!utcDateStr) return "";
    const date = new Date(utcDateStr);
    const istString = date.toLocaleString("en-IN", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    });

    // Format returned like: "10/07/2025, 16:45"
    const [datePart, timePart] = istString.split(", ");
    const [day, month, year] = datePart.split("/");
    return `${year}-${month}-${day}T${timePart}`;
  };
  useEffect(() => {
    if (data) {
      dispatch(
        setUpdateQuizForm({
          id: data.id || "",
          title: data.title || "",
          start: formatToISTDatetimeLocal(data.start_date),
          registrationStart: formatToISTDatetimeLocal(
            data.registration_start_date
          ),
          registrationEnd: formatToISTDatetimeLocal(data.registration_end_date),
          totalQuestions: data.total_questions || "",
          questionDuration: data.duration_per_question || "",
          enableSkippedMarks: !!data.negative_marks_skipped,
          enableWrongMarks: !!data.negative_marks_wrong,
          correct: data.marks_per_question || "",
          registrationCost: data.registration_fee,
          registrationFeeMode: data.registration_fee > 0.0 ? "paid" : "free",
          wrong: data.negative_marks_wrong || "",
          skipped: data.negative_marks_skipped || "",
          // allotments: data.allotments || [],
          winnerPrizes: Object.values(data.prizes || {}),
          topWinnersCount: Object.keys(data.prizes || {}).length,
          about_quiz: data.about_quiz,
          quiz_terms: data.quiz_terms,
          // data.quiz_terms,
          law_selected: data.allotments[0]?.law,
          updated_by: userId,
          prizeDescription: data.prizes,
          description: data.description,
        })
      );
      setStatee((prev) => ({
        ...prev,
        allotments: data.allotments,
      }));
    }
    dispatch(getLaws());
  }, [data]);

  function formatTerms(text) {
    if (!text) return "";

    const lines = text.split("\n").filter((l) => l.trim() !== "");

    let html = "<ol>";
    let inSubList = false;

    lines.forEach((line, idx) => {
      const trimmed = line.trim();

      // ✅ First line as heading (if it doesn’t start with a number.)
      if (idx === 0 && !/^\d+\./.test(trimmed)) {
        html = `<h3>${trimmed}</h3><ol>`;
        return;
      }

      // ✅ Main section (starts with number.)
      if (/^\d+\./.test(trimmed)) {
        if (inSubList) {
          html += "</ul>"; // close any open sublist
          inSubList = false;
        }
        // remove the leading number & dot
        const withoutNum = trimmed.replace(/^\d+\.\s*/, "");
        html += `<li><strong>${withoutNum}</strong><ul>`;
        inSubList = true;
      }
      // ✅ Sub-point
      else {
        if (inSubList) {
          html += `<li>${trimmed}</li>`;
        } else {
          html += `<p>${trimmed}</p>`;
        }
      }
    });

    if (inSubList) html += "</ul>";
    html += "</ol>";

    return html;
  }

  // useEffect(() => {
  //   if (!quiz_terms) return; // skip if no terms yet

  //   let updatedTerms = quiz_terms;

  //   // Use quiz_type (from API) not quizType
  //   if (Number(updateQuizForm.quizType) === 1) {
  //     // Replace total questions
  //     updatedTerms = updatedTerms.replace(
  //       /\*(\d+)\* objective questions/g,
  //       `*${totalQuestions}* objective questions`
  //     );

  //     // Replace seconds and per-question duration
  //     updatedTerms = updatedTerms.replace(
  //       / total duration of \*(\d+)\* seconds \(\*(\d+)\* seconds per question\)/g,
  //       `*${
  //         totalQuestions * questionDuration
  //       }* seconds (*${questionDuration}* seconds per question)`
  //     );
  //   }

  //   if (updatedTerms !== quiz_terms) {
  //     dispatch(setUpdateQuizForm({ key: "quiz_terms", value: updatedTerms }));
  //   }
  // }, [
  //   dispatch,
  //   quiz_terms,
  //   totalQuestions,
  //   questionDuration,
  //   updateQuizForm.quizType,
  // ]);

  const handleChange = (key, value) => {
    // if (key === "topWinnersCount") {
    //   const count = Number(value);
    //   const prizes = Array.from(
    //     { length: count },
    //     (_, i) => winnerPrizes[i] || ""
    //   );
    //   dispatch(setUpdateQuizForm({ key: "topWinnersCount", value: count }));
    //   dispatch(setUpdateQuizForm({ key: "winnerPrizes", value: prizes }));
    // }

    // else {
    dispatch(setUpdateQuizForm({ key, value }));

    // }
  };

  const handlePrizeChange = (index, value) => {
    dispatch(updateWinnerPrizeNew({ index, value }));
  };

  function handleAllotmentChange(difficulty_level) {
    if (
      !state.allotments.some(
        (item) => item.difficulty_level === difficulty_level
      )
    ) {
      setStatee((prev) => ({
        ...prev,
        allotments: [...prev.allotments, { difficulty_level, percentage: "" }],
      }));
    }
  }

  const removeAllotment = (difficulty_level) => {
    setStatee((prev) => ({
      ...prev,
      allotments: prev.allotments.filter(
        (a) => a.difficulty_level !== difficulty_level
      ),
    }));
  };
  function updatePercent(index, value) {
    setStatee((prev) => {
      const updated = prev.allotments.map((item, i) =>
        i === index ? { ...item, percentage: value } : item
      );
      return { ...prev, allotments: updated };
    });
  }

  const handleSubmit = async () => {
    const isLiveQuiz = selectedQuiz?.quiz_type === 1;
    const isPracticeQuiz = selectedQuiz?.quiz_type === 2;

    // ✅ Common validations
    const isCommonValid =
      title?.trim() &&
      start &&
      Number(totalQuestions) > 0 &&
      Number(questionDuration) > 0 &&
      about_quiz?.trim() &&
      quiz_terms?.trim() &&
      Array.isArray(state.allotments) &&
      state.allotments.length > 0;

    // ✅ Type-specific validations
    const isPracticeValid =
      isPracticeQuiz &&
      registrationStart &&
      registrationEnd &&
      registrationFeeMode &&
      registrationCost !== "" &&
      selectedQuiz.quizType &&
      isCommonValid;

    const isLiveValid =
      isLiveQuiz && law_selected && selectedQuiz.quiz_type && isCommonValid;

    // ✅ Allotment percentage validation
    if (
      isLiveQuiz &&
      state.allotments.reduce(
        (sum, a) => sum + Number(a.percentage || 0),
        0
      ) !== 100
    ) {
      alert("Total percentage of difficulty allotments must be exactly 100%");
      return;
    }

    // ✅ Date validations
    const now = Date.now();
    const regStart = Date.parse(registrationStart);
    const regEnd = Date.parse(registrationEnd);
    const startDate = Date.parse(start);

    if (isLiveQuiz) {
      if (regStart <= now) {
        alert("Registration start date must be in the future.");
        return;
      }
      if (regEnd <= regStart) {
        alert("Registration end date must be after registration start date.");
        return;
      }
      if (startDate <= regEnd) {
        alert("Start date of quiz must be after registration end date.");
        return;
      }
    }

    if (isPracticeQuiz && startDate <= now) {
      alert("Start date of quiz must be in the future.");
      return;
    }

    // ✅ Build request body
    const commonBody = {
      quiz_id: id,
      title,
      start_date: start,
      total_questions: Number(totalQuestions),
      duration_per_question: Number(questionDuration),
      marks_per_question: Number(correct),
      negative_marks_wrong: Number(wrong),
      negative_marks_skipped: Number(skipped),
      about_quiz,
      quiz_terms,
      quiz_type: Number(selectedQuiz?.quiz_type),
      updated_by,
      description,
    };

    let body = {};

    if (isLiveQuiz) {
      body = {
        ...commonBody,
        allotments: state.allotments.filter((a) => Number(a.percentage) > 0),
        registration_start_date: registrationStart,
        registration_end_date: registrationEnd,
        registration_fee: parseFloat(registrationCost).toFixed(2),
        prizes: prizeDescription,
        // winnerPrizes.reduce((acc, val, idx) => {
        //   acc[(idx + 1).toString()] = parseFloat(val).toFixed(2);
        //   return acc;
        // }, {}),
        registration_type: registrationFeeMode,
      };
    }

    if (isPracticeQuiz) {
      body = {
        ...commonBody,
        allotments: [{ law: Number(law_selected) }],
      };
    }

    console.log("Final Payload:", body);
    if (window.confirm("Are you sure to update quiz")) {
      try {
        // await axios.post("/admin/create-quiz", body);
        const res = await dispatch(updateQuiz(body));
        if (res) {
          console.log(res);
          alert(res?.payload?.message || "Quiz updated");
          setStatee({
            allotments: [],
          });
          dispatch(
            setState({
              key: "showPopup",
              value: false,
            })
          );
          dispatch(getQuizzes());
        }
      } catch (err) {
        console.error("Error details:", err);
        alert("Error creating quiz");
      }
    }
  };

  return (
    <div>
      <h2 className="mb-20" style={{ textAlign: "center", fontSize: "20px" }}>
        Edit Quiz
      </h2>
      {/* updated quiz {JSON.stringify(updateQuizForm)} */}
      <div className="form-group">
        <label className="form-label">Quiz Title</label>
        <input
          type="text"
          className="form-input"
          placeholder="Enter quiz title"
          value={title}
          onChange={(e) => handleChange("title", e.target.value)}
          required
        />
      </div>
      {/* <div className="form-group">
        <label className="form-label">Quiz Description</label>
        <input
          type="text"
          className="form-input"
          placeholder="Enter quiz description"
          value={description}
          onChange={(e) => handleChange("description", e.target.value)}
          required
        />
      </div> */}
      <div style={{ display: "flex", gap: "5%" }}>
        {selectedQuiz?.quiz_type === 1 && (
          <>
            <div className="form-group">
              <label className="form-label">Registration Quiz Date</label>
              <input
                type="datetime-local"
                className="form-input"
                value={registrationStart}
                onChange={(e) =>
                  handleChange("registrationStart", e.target.value)
                }
                required
              />
            </div>
            <div className="form-group">
              <label className="form-label">Registration End Date</label>
              <input
                type="datetime-local"
                className="form-input"
                value={registrationEnd}
                onChange={(e) =>
                  handleChange("registrationEnd", e.target.value)
                }
                required
              />
            </div>
          </>
        )}
        <div className="form-group">
          <label className="form-label">Quiz Date</label>
          <input
            type="datetime-local"
            className="form-input"
            value={start}
            onChange={(e) => handleChange("start", e.target.value)}
            required
          />
        </div>
      </div>
      <div style={{ display: "flex", gap: "5%" }}>
        <div className="form-group">
          <label className="form-label">Total Question(s)</label>
          <input
            type="number"
            className="form-input"
            value={totalQuestions}
            onChange={(e) =>
              handleChange("totalQuestions", Number(e.target.value))
            }
            required
          />
        </div>
        <div className="form-group">
          <label className="form-label">Question Duration (in seconds)</label>
          <input
            type="number"
            className="form-input"
            value={questionDuration}
            onChange={(e) =>
              handleChange("questionDuration", Number(e.target.value))
            }
            required
          />
        </div>
      </div>
      <div style={{ display: "flex", gap: "5%" }}>
        <div className="form-group">
          <label className="form-label">Marks For correct answer</label>
          <input
            type="number"
            className="form-input"
            value={correct}
            min="1"
            onChange={(e) => handleChange("correct", e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label className="form-label">
            <input
              type="checkbox"
              checked={enableWrongMarks}
              onChange={(e) =>
                handleChange("enableWrongMarks", e.target.checked)
              }
            />{" "}
            Negative Marking For Wrong Answer
          </label>
          {enableWrongMarks && (
            <input
              type="number"
              className="form-input"
              placeholder="Marks for wrong answer"
              value={wrong}
              max="0"
              onChange={(e) => handleChange("wrong", e.target.value)}
              disabled={!enableWrongMarks}
            />
          )}
        </div>

        <div className="form-group">
          <label className="form-label">
            <input
              type="checkbox"
              checked={enableSkippedMarks}
              onChange={(e) =>
                handleChange("enableSkippedMarks", e.target.checked)
              }
            />{" "}
            Negative MarkingMarks For Skipped Answer
          </label>
          {enableSkippedMarks && (
            <input
              type="number"
              className="form-input"
              placeholder="Marks for skipped answer"
              value={skipped}
              max="0"
              onChange={(e) => handleChange("skipped", e.target.value)}
              disabled={!enableSkippedMarks}
            />
          )}
        </div>
      </div>
      {selectedQuiz?.quiz_type === 1 && (
        <>
          <div className="flex gap-6 mb-4">
            <label className="form-label font-medium">Registration Fee</label>

            <div className="flex items-center gap-6">
              <label className="inline-flex items-center">
                <input
                  type="radio"
                  name="registrationFeeMode"
                  value="free"
                  checked={registrationFeeMode === "free"}
                  onChange={(e) =>
                    handleChange("registrationFeeMode", e.target.value)
                  }
                  className="form-radio text-blue-600"
                  required
                />
                <span className="ml-2">Free</span>
              </label>

              <label className="inline-flex items-center">
                <input
                  type="radio"
                  name="registrationFeeMode"
                  value="paid"
                  checked={registrationFeeMode === "paid"}
                  onChange={(e) =>
                    handleChange("registrationFeeMode", e.target.value)
                  }
                  className="form-radio text-blue-600"
                  required
                />
                <span className="ml-2">Paid</span>
              </label>
            </div>
          </div>

          {registrationFeeMode === "paid" && (
            <div className="flex items-center gap-4 mb-4">
              <label className="font-medium">Registration Cost</label>
              <input
                type="number"
                name="registrationCost"
                value={registrationCost}
                onChange={(e) =>
                  handleChange("registrationCost", e.target.value)
                }
                className="form-input border p-2 rounded"
                required
                min="0"
              />
            </div>
          )}

          <div className="mt-4">
            <h4 style={{ fontSize: "16px" }}>Winner Prize Details</h4>
            <textarea
              onChange={(e) => {
                console.log(e.target.value);
                handleChange("prizeDescription", e.target.value);
              }}
              value={prizeDescription}
              className="form-control"
              placeholder="Enter the winner price details..."
            />
          </div>
          <div>
            <h4>Question Allotment Form</h4>
            <div className="form-group">
              <label className="form-label">Add Difficulty Level</label>
              <select
                className="form-input"
                onChange={(e) => handleAllotmentChange(e.target.value)}
                value=""
              >
                <option value="">Select</option>
                <option value="basic">Basic</option>
                <option value="advanced">Advanced</option>
                <option value="ultra">Ultra</option>
                <option value="docmaster">Docmaster</option>
              </select>
            </div>
            <div style={{ marginTop: "10px" }}>
              <strong>Total: </strong>
              <span
                style={{
                  color:
                    state.allotments.reduce(
                      (sum, a) => sum + Number(a.percentage || 0),
                      0
                    ) === 100
                      ? "green"
                      : "red",
                }}
              >
                {state.allotments.reduce(
                  (sum, a) => sum + Number(a.percentage || 0),
                  0
                )}
                %
              </span>{" "}
              (must be exactly 100%)
            </div>
            {state.allotments.map((each, index) => (
              <div
                key={index}
                style={{ display: "flex", gap: "2rem", marginBottom: "10px" }}
              >
                <p style={{ minWidth: "100px" }}>
                  <strong>{each.difficulty_level}</strong>
                </p>
                <input
                  type="number"
                  className="form-control"
                  placeholder="Enter percentage"
                  value={each.percentage}
                  onChange={(e) => updatePercent(index, Number(e.target.value))}
                />
                <button
                  type="button"
                  onClick={() => removeAllotment(each.difficulty_level)}
                >
                  Remove
                </button>
              </div>
            ))}
          </div>
        </>
      )}
      {selectedQuiz?.quiz_type === 2 && (
        <>
          <div>
            <div className="form-group">
              <label className="form-label">Laws</label>
              <select
                className="form-control"
                value={law_selected}
                onChange={(e) => {
                  handleChange("law_selected", e.target.value);
                }}
              >
                <option value="">Select</option>
                {categories?.map((e) => (
                  <option key={e.id} value={e.id}>
                    {e.name}
                  </option>
                ))}{" "}
              </select>
            </div>
          </div>
        </>
      )}
      <h3 style={{ textAlign: "center", fontSize: "20px" }}>
        Terms and conditions
      </h3>
      <div className="form-group">
        <label className="form-label">About Quiz</label>
        <textarea
          className="form-input"
          value={about_quiz}
          onChange={(e) => handleChange("about_quiz", e.target.value)}
          required
        />
      </div>

      <div className="form-group">
        <label className="form-label">Terms and conditions</label>
        <textarea
          className="form-input"
          style={{ height: "60vh" }}
          value={quiz_terms}
          onChange={(e) => handleChange("quiz_terms", e.target.value)}
          required
        />
      </div>
      <div
        className="mt-4 p-3 border rounded bg-gray-50"
        style={{ height: "30vh", overflow: "auto" }}
      >
        <p>
          <strong>Note:</strong>
          Please ensure that the following variables are not removed from the
          Terms and Conditions section above.
        </p>
        <p>
          <strong>Variables used in the Terms and Conditions:</strong>
          <ol>
            <li>
              [Number] – Represents the total number of questions in the quiz.
            </li>
            <li>
              [X seconds] – Represents the total duration of the quiz,
              calculated as
              <em> total questions × duration per question (in seconds)</em>.
            </li>
            <li>
              [X second] – Represents the duration allocated for each question
              (in seconds).
            </li>
            <li>
              [Correct] – Represents the score awarded for each correct answer.
            </li>
          </ol>
        </p>
      </div>
      <div
        className="mt-4 p-3 border rounded bg-gray-50"
        style={{ height: "60vh", overflow: "auto" }}
      >
        <h4 className="mb-2 font-semibold" style={{ textAlign: "center" }}>
          Preview of Terms and Conditions
        </h4>
        <div
          dangerouslySetInnerHTML={{
            __html: formatTerms(quiz_terms),
          }}
        />
      </div>

      <button className="btn btn-primary w-full mt-20" onClick={handleSubmit}>
        Update Quiz
      </button>
    </div>
  );
}
